const SectionSignUp = Class(
	/**
	 * @lends {SectionSignUp#}
	 */
	{
		bodyClass: 'small-nav',

		__construct() {
			this.node = mkE({
				tag: 'div',
				id: 'sign-up',
				className: 'container'
			});
		},

		draw() {
			this.node.append(this.layout.ct());
			let className = 'left';
			let isBannerEnabled = false;
			if( isBannerEnabled ) {
				mkE({
					tag: 'div',
					className: 'left-empty',
					els: [
						{
							tag: 'div',
							className: 'banner',
							innerHTML: D.Lang.get('sign-up.banner.text')
						}
					]
				}).append(this.node);
				className = 'right';
			}

			mkE({
				tag: 'div',
				className: className,
				els: [
					this._form = new SectionSignUp.Form(this.url)
				]
			}).append(this.node);
			this.ready();
		}
	},
	Section
);

SectionSignUp.Form = Class(
	/**
	 * @lends {SectionSignUp.Form#}
	 */
	{
		_fields: {},

		__construct(url) {
			this.url = url;

			let signInUrl = new Get(D.url('sign-in'));
			if (this.url.get.is('redirect')) {
				signInUrl.add('redirect', this.url.get.v('redirect'));
			}
			this.node = mkE({
				tag: 'div',
				className: 'sign-up-form',
				els: [
					{
						tag: 'div',
						className: 'top',
						els: [
							{
								tag: 'h1',
								className: 'h2',
								text: D.Lang.get('sign-up.title')
							},
							{
								tag: 'div',
								className: 'caption',
								els: [
									D.Lang.get('sign-up.caption') + ' ',
									{
										tag: 'a',
										href: signInUrl.toUrl(),
										text: D.Lang.get('sign-up.login')
									}
								]
							}
						]
					}
				]
			});

			mkE({
				tag: 'div',
				className: 'auth',
				els: [
					{
						tag: 'div',
						className: 'social-auth',
						els: [
							{
								tag: 'a',
								className: 'facebook',
								onclick: D.Social.facebook,
								title: D.Lang.get('sign-up.social.facebook'),
								els: [
									{
										tag: 'span'
									},
									{
										tag: 'b',
										text: D.Lang.get('sign-up.social.facebook')
									}
								]
							},
							{
								tag: 'a',
								className: 'google',
								onclick: D.Social.google,
								title: D.Lang.get('sign-up.social.google'),
								els: [
									{
										tag: 'span'
									},
									{
										tag: 'b',
										text: D.Lang.get('sign-up.social.google')
									}
								]
							},
							{
								tag: 'a',
								className: 'draugiem',
								onclick: D.Social.draugiem,
								title: D.Lang.get('sign-up.social.draugiem'),
								els: [
									{
										tag: 'span'
									},
									{
										tag: 'b',
										text: D.Lang.get('sign-up.social.draugiem')
									}
								]
							}
						]
					},
					{
						tag: 'div',
						className: 'or',
						els: [
							{
								tag: 'div',
								className: 'line line-1'
							},
							{
								tag: 'div',
								className: 'text',
								text: D.Lang.get('sign-up.or')
							},
							{
								tag: 'div',
								className: 'line line-1'
							}
						]
					},
					this._authForm = mkE({
						tag: 'div',
						className: 'auth-form'
					})
				]
			}).append(this.node);

			this._drawForm();
		},

		_drawForm() {
			this._form = mkE({
				tag: 'form',
				className: 'form',
				prop: {
					onsubmit: this._submit
				}
			}).append(this._authForm);

			mkE({
				tag: 'div',
				className: 'row',
				els: [
					{
						tag: 'div',
						els: [
							this._fields['name'] = new T.Form.Input({
								caption: D.Lang.get('sign-up.form.name'),
								attr: {
									autofocus: true,
									autocomplete: 'name'
								}
							})
						]
					}
				]
			}).append(this._form);

			mkE({
				tag: 'div',
				className: 'row',
				els: [
					this._fields['email'] = new T.Form.Input({
						caption: D.Lang.get('sign-up.form.email'),
						type: 'email',
						attr: {
							autocomplete: 'email'
						},
						value: D.SESSION_INVITE_EMAIL
					})
				]
			}).append(this._form);

			mkE({
				tag: 'div',
				className: 'row',
				els: [
					this._fields['password'] = new T.Form.Input({
						caption: D.Lang.get('sign-up.form.password'),
						type: 'password',
						placeholder: D.Lang.get('sign-up.form.password_placeholder'),
						attr: {
							autocomplete: 'new-password'
						}
					})
				]
			}).append(this._form);

			mkE({
				tag: 'div',
				className: 'row bottom',
				els: [
					{
						tag: 'div',
						className: 'left',
						els: [
							{
								tag: 'button',
								className: 'button button-pink button-block',
								text: D.Lang.get('sign-up.form.submit'),
								onclick: this._submit
							}
						]
					},
					{
						tag: 'div',
						className: 'right',
						els: [
							D.Lang.get('sign-up.form.rules_caption') + ' ',
							{
								tag: 'a',
								href: D.url('/terms'),
								target: '_blank',
								text: D.Lang.get('sign-up.form.rules_link')
							},
							'. ',
							D.Lang.get('sign-up.form.privacy_caption') + ' ',
							{
								tag: 'a',
								href: D.url('/privacy-policy'),
								target: '_blank',
								text: D.Lang.get('sign-up.form.privacy_link')
							},
							'.'
						]
					}
				]
			}).append(this._form);
		},

		_submit() {
			if (this._isSubmitting) {
				return false;
			}
			if (this._errorNode) {
				this._errorNode.remove();
			}
			let data = {};
			let hasError = false;
			for (let field in this._fields) {
				if (!this._fields.hasOwnProperty(field)) {
					continue;
				}
				this._fields[field].error(null);
				if (!this._fields[field].value()) {
					hasError = true;
					this._fields[field].error(D.Lang.get('sign-up.errors.empty'))
				} else if (field === 'email' && !T.Form.isValidEmail(this._fields[field].value())) {
					hasError = true;
					this._fields[field].error(D.Lang.get('sign-up.errors.' + field + '.format'))
				}
				data[field] = this._fields[field].value();
			}
			if (hasError) {
				return false;
			}
			delete data.password2;
			data.lang = D.LANG;
			if (this.url.get.is('redirect')) {
				data['redirect'] = this.url.get.v('redirect');
			}
			this._isSubmitting = true;
			new RPC('/api/web_rpc.php').send('register', data, this._onSubmit);
			return false;
		},

		_onSubmit(re) {
			if (empty(re)) {
				this._errorNode = T.error(D.Lang.get('sign-up.errors.general'), true).prepend(this._form);
				return;
			}
			if (re.ok) {
				D.Analytics.branch('COMPLETE_REGISTRATION', {
					"description": "Registration completed",
					"user_id": re.userId
				});
				window.location.href = D.url('verify-email');
				return;
			}
			this._isSubmitting = false;
			if (!empty(re.error)) {
				if (typeof re.error === 'object') {
					for (let field in re.error) {
						if (!re.error.hasOwnProperty(field)) {
							continue;
						}
						this._fields[field].error(D.Lang.get('sign-up.errors.' + field + '.' + re.error[field]));
					}
				} else {
					this._errorNode = T.error(D.Lang.get('sign-up.errors.general'), true).prepend(this._form);
				}
			}
		}
	},
	mkE.Base
);
